export default {
  getLanguages(state) {
    return state.language;
  },
};
